EMRAdmin.factory('EMRUsersLinkedToFacilityCommonFactory', ['$q', '$injector', function ($q, $injector) {


    var EMRUsersLinkedToFacilityList = [];
    var sucessfullyGotDataFromAPICall = false;
    var EMRUsersLinkedToFacilityCommonFactoryInstance = {


        setEMRUsersLinkedToFacilityList: function (serviceResponse) {
            if (serviceResponse && serviceResponse.UsersLinkedToFacilityList && serviceResponse.UsersLinkedToFacilityList.length > 0) {
                EMRUsersLinkedToFacilityList = serviceResponse.UsersLinkedToFacilityList;
                sucessfullyGotDataFromAPICall = true;//if web worker worked well and got data then no need to get data again so making this flag true
            }
        },


        getEMRUsersLinkedToFacilityList: function () {
            var deferred = $q.defer();
            if (EMRPracticeModel.ShowUsersbasedonLoggedFacility) {
                if ((EMRUsersLinkedToFacilityList && EMRUsersLinkedToFacilityList.length > 0) || sucessfullyGotDataFromAPICall) {
                    deferred.resolve(EMRUsersLinkedToFacilityList);
                }
                else {
                    //injecting dynamically as we are having common factory injected in RxCommonService cause injecting this may lead to circular dependency error
                    var RxDynamicService = $injector.get('RxCommonService');
                    RxDynamicService.GetUsersLinkedToFacility().then(function (serviceResponse) {
                        //whenever an error occured then returning the no value
                        if (isError(serviceResponse)) {
                            sucessfullyGotDataFromAPICall = false;
                            //resolving the saved information in the object
                            deferred.resolve([]);
                            return;
                        }
                        sucessfullyGotDataFromAPICall = true;
                        //setting the data in local based on the enum keys in the memory
                        if (serviceResponse && serviceResponse.UsersLinkedToFacilityList && serviceResponse.UsersLinkedToFacilityList.length > 0) {
                            EMRUsersLinkedToFacilityList = serviceResponse.UsersLinkedToFacilityList;
                        }

                        //resolving the saved information in the object
                        deferred.resolve(EMRUsersLinkedToFacilityList);
                    });
                }
            } else {
                deferred.resolve([]);
            }
            return deferred.promise;
        },






    }
    return EMRUsersLinkedToFacilityCommonFactoryInstance;

}]);